import { render, staticRenderFns } from "./TasksPage.vue?vue&type=template&id=c7e1d63c"
import script from "./TasksPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TasksPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7e1d63c')) {
      api.createRecord('c7e1d63c', component.options)
    } else {
      api.reload('c7e1d63c', component.options)
    }
    module.hot.accept("./TasksPage.vue?vue&type=template&id=c7e1d63c", function () {
      api.rerender('c7e1d63c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Pages/TaskManagement/Components/TasksPage.vue"
export default component.exports